import React from 'react';
import { NavLink } from 'react-router-dom';
import { BrandInfoModels } from 'types/drupal/BrandInfo';

interface Props {
    brand: string;
    brandModel: BrandInfoModels;
    isMobile: boolean;
    year: string;
}

const BrandInfoModelLink: React.StatelessComponent<Props> = (props: Props) => {

    const yearCoalesce = props.year || 'all';
    const path = '/brands/' + props.brand + '/' + yearCoalesce + '/' + props.brandModel.slug;

    if (props.isMobile) {
        return (
            <div>
                <NavLink to={path} >
                    {props.brandModel.model} ({props.brandModel.count})
                </NavLink>
            </div>
        );
    }

    return (
            <li>
                <NavLink to={path} >
                {props.brandModel.model} ({props.brandModel.count})
                </NavLink>
            </li>
    );
};

export default BrandInfoModelLink;



// WEBPACK FOOTER //
// ./src/components/pages/brand/BrandInfoModelLink.tsx